<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-form`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M40 3a2 2 0 012 2v38a2 2 0 01-2 2H8a2 2 0 01-2-2V5a2 2 0 012-2h32zm-2 4H10v34h28V7zM27 30a1 1 0 011 1v2a1 1 0 01-1 1H16a1 1 0 01-1-1v-2a1 1 0 011-1h11zm5-9a1 1 0 011 1v2a1 1 0 01-1 1H16a1 1 0 01-1-1v-2a1 1 0 011-1h16zm0-9a1 1 0 011 1v2a1 1 0 01-1 1H16a1 1 0 01-1-1v-2a1 1 0 011-1h16z"/></svg>
</template>
<script>

export default {
  name: 'IconForm',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
